import i18n from "@/libs/i18n";
import { useWebhooksStore } from "@/store/useWebhooksStore";
import { RequestQueryBuilder } from "@rewiko/crud-request";
import { computed, ref, watch } from "@vue/composition-api";

export default function useWebhooks() {
    const refTable = ref(null);
    const tableColumns = [
        {
            key: "event",
            label: i18n.t("settings.developers.webhooks.event"),
            sortable: true,
            thStyle: "width: 10%",
        },
        {
            key: "version",
            label: i18n.t("settings.developers.webhooks.version"),
            sortable: true,
            thStyle: "width: 10%",
        },
        {
            key: "url",
            label: i18n.t("settings.developers.webhooks.url"),
            sortable: true,
        },
        {
            key: "headers",
            label: i18n.t("settings.developers.webhooks.additional-headers"),
            sortable: true,
            thStyle: "width: 25%",
        },
        {
            key: "enabled",
            label: i18n.t("settings.developers.webhooks.enabled"),
            sortable: true,
            thStyle: "width: 10%",
        },
        { key: "actions", label: i18n.t("settings.users.actions"), thStyle: "width: 15%" },
    ];
    const perPage = ref(10);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(false);

    const dataMeta = computed(() => {
        const localItemsCount = refTable.value ? refTable.value.localItems.length : 0;

        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: total.value,
        };
    });

    const read = () => {
        const { fetchWebhooks } = useWebhooksStore();

        fetchWebhooks(
            RequestQueryBuilder.create({
                fields: ["id", "event", "enabled", "url", "version", "headers"],
                limit: perPage.value,
                page: currentPage.value,
                sort: {
                    field: sortBy.value,
                    order: isSortDirDesc.value === true ? "DESC" : "ASC",
                },
            })
        );
    };

    const refetchData = () => {
        refTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        if (searchQuery.value.length > 0 && searchQuery.value.length < 2) {
            return;
        }

        refetchData();
    });

    return {
        read,
        refetchData,
        tableColumns,
        perPage,
        currentPage,
        total,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTable,
    };
}
